import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, null, -1)
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_component_a_table, {
      key: _ctx.computedCodigoBalancoEstoque,
      columns: _ctx.gradeBase.colunas.filter(item => item.visible),
      "data-source": _ctx.state.itens,
      rowKey: "codigo",
      pagination: false,
      scroll: { x: _ctx.state.larguraGrade },
      loading: _ctx.gradeBase.buscandoDados,
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'QuantidadeEstoque')
          ? (_openBlock(), _createBlock(_component_campo_numerico, {
              key: 0,
              valor: record.quantidadeEstoque,
              "onUpdate:valor": ($event: any) => ((record.quantidadeEstoque) = $event),
              quantidadeCasasDecimais: record.casasDecimais,
              disabled: true
            }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais"]))
          : (column.key === 'QuantidadeAjuste')
            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                key: 1,
                valor: record.quantidadeAjuste,
                "onUpdate:valor": ($event: any) => ((record.quantidadeAjuste) = $event),
                quantidadeCasasDecimais: record.casasDecimais,
                disabled: true
              }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais"]))
            : (column.key === 'QuantidadeSaldoFinal')
              ? (_openBlock(), _createBlock(_component_campo_numerico, {
                  key: 2,
                  valor: record.quantidadeSaldoFinal,
                  "onUpdate:valor": ($event: any) => ((record.quantidadeSaldoFinal) = $event),
                  quantidadeCasasDecimais: record.casasDecimais,
                  disabled: true
                }, null, 8, ["valor", "onUpdate:valor", "quantidadeCasasDecimais"]))
              : _createCommentVNode("", true)
      ]),
      emptyText: _withCtx(() => [
        _createVNode(_component_mensagem_sem_dados, {
          adicionarDado: true,
          mensagem: _ctx.gradeBase.buscandoDados?'Buscando informações, por favor aguarde...':'Nenhum item encontrado, verifique se os dados do balanço estão corretos.'
        }, null, 8, ["mensagem"])
      ]),
      _: 1
    }, 8, ["columns", "data-source", "scroll", "loading"])),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_totalizador, {
          titulo: "TOTAL ITENS",
          valor: _ctx.state.quantidadeItens,
          monetario: false
        }, null, 8, ["valor"])
      ])
    ], 512), [
      [_vShow, (!_ctx.gradeBase.buscandoDados)]
    ])
  ]))
}